import React from 'react';
import { RISK_EXAMPLE } from '../../../data/exampleReviews';
import { ExampleFrame } from '../../examples/ExampleFrame';
import { StatusPill } from '../../examples/StatusPill';
export function RiskRegister() {
  return <ExampleFrame title={`Risk register · ${RISK_EXAMPLE.counterparty}`} subtitle="Prospective partner review" caption="Fictional counterparty and reviewers." data-id="element-1043" data-mp="140qzuqx9fe49">
      <ul className="flex flex-col gap-2" data-id="element-1044" data-mp="bbada9wbmrfy">
        {RISK_EXAMPLE.rows.map(row => <li key={row.area} className="rounded-xl border border-hairline-soft px-3.5 py-3" data-id="element-1045" data-mp="ga4u56aqa5xf">
            <div className="flex items-center justify-between gap-2" data-id="element-1046" data-mp="g7qzuznvgxqx">
              <p className="text-[11px] font-semibold uppercase tracking-[0.08em] text-text-tertiary" data-id="element-1047" data-mp="ka5mluunwhnh">{row.area}</p>
              <StatusPill status={row.status} data-id="element-1048" data-mp="p4jl464mf4wd" />
            </div>
            <p className="mt-1 text-sm font-medium text-text-primary" data-id="element-1049" data-mp="3op5cv9o2w28h">{row.finding}</p>
            <dl className="mt-1.5 flex flex-wrap gap-x-4 gap-y-0.5 text-xs text-text-secondary" data-id="element-1050" data-mp="3sqqo6qkys8gk">
              <div className="flex gap-1" data-id="element-1051" data-mp="ynq54fzgpnin">
                <dt className="text-text-tertiary" data-id="element-1052" data-mp="ypjbrva2s7qn">Owner</dt>
                <dd data-id="element-1053" data-mp="tpevo6d2xf0y">{row.owner}</dd>
              </div>
              <div className="flex gap-1" data-id="element-1054" data-mp="oxndok7zohmf">
                <dt className="text-text-tertiary" data-id="element-1055" data-mp="owlqjhdp84oc">Next action</dt>
                <dd className={row.next === 'None' ? '' : 'font-semibold text-lime'} data-id="element-1056" data-mp="jytxgk1bicik">{row.next}</dd>
              </div>
            </dl>
          </li>)}
      </ul>
    </ExampleFrame>;
}